<ion-modal
    class="time-modal pb-[var(--ion-safe-area-bottom)] pt-[var(--ion-safe-area-top)]"
    [trigger]="triggerId"
    [ngClass]="{ 'high-contrast': (isContrast$ | async) }"
    (willPresent)="willPresent()"
    (willDismiss)="willDismiss()"
    (ionModalDidPresent)="ionModalDidPresents()"
    role="dialog"
    aria-modal="true">
    <ng-template>
        <div class="modal-wrapper">
            <div class="flex h-auto min-h-[4rem] flex-shrink-0 items-center px-4 py-2">
                <div class="h-11 w-11 flex-shrink-0" aria-hidden="true"></div>

                <h2
                    class="var-app-light-dark:font-bold orb-app-light-dark:font-bold min-w-0 flex-1 py-4 text-center text-base font-semibold leading-normal">
                    {{ (dateOnly ? 'DATETIME_MODAL_SET_DATE' : 'DATETIME_MODAL_SET_DATE_AND_TIME') | translate }}
                </h2>

                <ion-button
                    class="back-button my-0 ml-0 mr-2 flex-shrink-0 text-secondary"
                    [attr.aria-label]="'LOCAL_BTN_CLOSE' | translate"
                    (click)="closeModal()"
                    fill="clear">
                    <ion-icon
                        class="vl-app-light:filter-none vl-app-light:text-grey-dark orb-app-light:text-grey-zambezy var-app-light:text-grey-zambezy text-black dark:text-contrast-yellow"
                        src="{{ assetsPath$ | async }}/img/journey-planner/icon-cross.svg"></ion-icon>
                </ion-button>
            </div>

            <div class="modal-content px-4 pb-4">
                <ion-segment
                    class="orb-app-light-dark:mb-0 mb-4"
                    *ngIf="showDepartArriveToggle"
                    [(ngModel)]="internalDepartureArrivalVal.type"
                    color="light">
                    <ion-segment-button [attr.aria-label]="'DATETIME_MODAL_LEAVE_AFTER' | translate" value="leaveAfter">
                        <ion-label class="orb-app-light-dark:font-semibold orb-app-light-dark:text-base">{{
                            'DATETIME_MODAL_LEAVE_AFTER' | translate
                        }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [attr.aria-label]="'DATETIME_MODAL_ARRIVE_BY' | translate" value="arriveBy">
                        <ion-label class="orb-app-light-dark:font-semibold orb-app-light-dark:text-base">{{
                            'DATETIME_MODAL_ARRIVE_BY' | translate
                        }}</ion-label>
                    </ion-segment-button>
                </ion-segment>

                <ridango-datetime-picker
                    [(ngModel)]="internalDepartureArrivalVal.datetime"
                    [firstDayOfWeek]="1"
                    [min]="minDate"
                    [max]="maxDate"
                    [presentation]="dateOnly ? 'date' : 'date-time'"
                    [forceNativeDatePresentation]="forceNativeDatePresentation"
                    [color]="['vastmanland-app', 'varmland-app'].includes(env.APP_NAME) ? 'primary' : 'secondary'"
                    [locale]="locale"
                    (ionFocus)="addCloseButton()"
                    hourCycle="h23"
                    size="cover">
                    <ion-label
                        class="orb-app-light:text-black orb-app-light:font-semibold var-app-light:text-black var-app-light:font-semibold"
                        slot="time-label"
                        >{{ 'TIME' | translate }}</ion-label
                    >
                </ridango-datetime-picker>

                <hr class="mb-0 border-b border-solid dark:border-contrast-yellow" />

                <ion-button
                    class="reset-button var-app-light:text-primary var-app-light:font-semibold orb-app-light-dark:text-xm orb-app-light-dark:font-semibold min-h-16 my-0 h-auto w-full whitespace-normal text-base font-medium normal-case text-secondary dark:filter-yellow"
                    [attr.aria-label]="
                        resetFilter
                            ? ('RESET_FILTER' | translate)
                            : ((dateOnly
                                  ? 'DATETIME_MODAL_RESET_TO_CURRENT_DATE'
                                  : 'DATETIME_MODAL_RESET_TO_CURRENT_DATE_AND_TIME'
                              ) | translate)
                    "
                    (click)="resetToCurrent()"
                    (keydown.enter)="resetToCurrent()"
                    fill="clear">
                    <ion-icon
                        class="var-app-light-dark:h-8 var-app-light-dark:w-8 orb-app-light-dark:h-8 orb-app-light-dark:w-8 mr-1 flex h-4 w-4 flex-shrink-0 text-base"
                        aria-hidden="true"
                        src="{{ assetsPath$ | async }}/img/journey-planner/icon-reset.svg"></ion-icon>
                    <span class="break-words">
                        {{
                            resetFilter
                                ? ('RESET_FILTER' | translate)
                                : ((dateOnly
                                      ? 'DATETIME_MODAL_RESET_TO_CURRENT_DATE'
                                      : 'DATETIME_MODAL_RESET_TO_CURRENT_DATE_AND_TIME'
                                  ) | translate)
                        }}
                    </span>
                </ion-button>

                <ion-button
                    class="set-datetime-button pn-app-light:text-white pn-app-light:bg-primary pn-light:text-white pn-light:bg-primary gl-light:text-[var(--color-primary)] vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black vl-app-light-dark:mt-0 sr-app-light-dark:mt-0 var-app-light:text-primary var-app-light-dark:font-semibold orb-app-light-dark:font-semibold orb-app-light:bg-primary orb-app-light:text-black my-0 mt-4 h-auto min-h-[4rem] w-full break-words rounded-lg bg-secondary text-base font-medium normal-case tracking-normal text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    [attr.aria-label]="
                        (dateOnly ? 'DATETIME_MODAL_SET_DATE' : 'DATETIME_MODAL_SET_DATE_AND_TIME') | translate
                    "
                    (click)="confirmChanges()"
                    fill="clear">
                    {{ (dateOnly ? 'DATETIME_MODAL_SET_DATE' : 'DATETIME_MODAL_SET_DATE_AND_TIME') | translate }}
                </ion-button>
            </div>
        </div>
    </ng-template>
</ion-modal>
